import {Component} from '@angular/core';
import {ImageMarqueeComponent} from '../../../../shared/components/image-marquee/image-marquee.component';
import {ButtonComponent} from '../../../../shared/components/button/button.component';

@Component({
    selector: 'wci-hero',
    imports: [ImageMarqueeComponent, ButtonComponent],
    templateUrl: './hero.component.html',
    styles: `
        .button-stroke {
            stroke-dasharray: 1000px;
            stroke-dashoffset: 1000px;
            animation: drawStroke 8s ease-in-out infinite;
            animation-delay: 1s; /* ⏱️ Startverzögerung */
        }

        @keyframes drawStroke {
            0% {
                stroke-dashoffset: 1000px; /* Start */
            }
            5% {
                stroke-dashoffset: 0; /* Gezeichnet (0.4s von 8s) */
            }
            68% {
                stroke-dashoffset: 0; /* Sichtbar bleiben (ca. 5.4s) */
            }
            75% {
                stroke-dashoffset: 1000px; /* Rücksprung (0.56s) */
            }
            100% {
                stroke-dashoffset: 1000px; /* Pause (2s ab hier bis Neustart) */
            }
        }

    `,
})
export class HeroComponent {
    screen_strip: { image: string; name: string }[] = [
        { image: 'images/projects/wecodeit-project-ortner-2.avif', name: 'ortner' },
        { image: 'images/projects/wecodeit-project-tenka-hero.avif', name: 'tenka' },
        { image: 'images/projects/wecodeit-project-leadmetrics-4.avif', name: 'leadmetrics' },
        { image: 'images/projects/wecodeit-project-bier-vom-sir-1.avif', name: 'bier-vom-sir' },
        { image: 'images/projects/wecodeit-project-solarplex-3.avif', name: 'solarplex' },
        { image: 'images/projects/wecodeit-project-pertl-2.avif', name: 'pertl' },
        { image: 'images/projects/wecodeit-project-user-labs-2.avif', name: 'user-labs' },
        { image: 'images/projects/wecodeit-project-hydrotek-1.avif', name: 'hydrotek' },
        { image: 'images/projects/wecodeit-project-masaniello-3.avif', name: 'masaniello' },
        { image: 'images/projects/wecodeit-project-jakobeckhart-2.avif', name: 'jakobeckhart' },
        { image: 'images/projects/wecodeit-project-xpd-2.avif', name: 'xpd' },
        { image: 'images/projects/wecodeit-project-tenka-1.avif', name: 'tenka' },
        { image: 'images/projects/wecodeit-project-wci1.avif', name: 'wci1' },
        { image: 'images/projects/wecodeit-project-leadmetrics-2.avif', name: 'leadmetrics' },
        { image: 'images/projects/wecodeit-project-copilot.avif', name: 'copilot' },
        { image: 'images/projects/wecodeit-project-supportive.avif', name: 'supportive' },
        { image: 'images/projects/wecodeit-project-gp-stocker-1.avif', name: 'gp-stocker' },
        { image: 'images/projects/wecodeit-project-seek-2.avif', name: 'seek' },
        { image: 'images/projects/wecodeit-project-ortner-1.avif', name: 'ortner' },
        { image: 'images/projects/wecodeit-project-leadmetrics-1.avif', name: 'leadmetrics' },
        { image: 'images/projects/wecodeit-project-bogner-melkes-1.avif', name: 'bogner-melkes' },
        { image: 'images/projects/wecodeit-project-threedee.avif', name: 'threedee' },
        { image: 'images/projects/wecodeit-project-fcg-younion-2.avif', name: 'fcg-younion' },
        { image: 'images/projects/wecodeit-project-user-labs-1.avif', name: 'user-labs' },
        { image: 'images/projects/wecodeit-project-ziegelwerk-2.avif', name: 'ziegelwerk' },
        { image: 'images/projects/wecodeit-project-tgmc-1.avif', name: 'tgmc' },
        { image: 'images/projects/wecodeit-project-jakobeckhart-3.avif', name: 'jakobeckhart' },
        { image: 'images/projects/wecodeit-project-sfwinterbach.avif', name: 'sfwinterbach' },
        { image: 'images/projects/wecodeit-project-masaniello-1.avif', name: 'masaniello' },
        { image: 'images/projects/wecodeit-project-tecbit-2.avif', name: 'tecbit' },
        { image: 'images/projects/wecodeit-project-tenka-2.avif', name: 'tenka' },
        { image: 'images/projects/wecodeit-project-gc-2.avif', name: 'gc' },
        { image: 'images/projects/wecodeit-project-seek-3.avif', name: 'seek' },
        { image: 'images/projects/wecodeit-project-tenka-3.avif', name: 'tenka' },
        { image: 'images/projects/wecodeit-project-fcg-younion-3.avif', name: 'fcg-younion' },
        { image: 'images/projects/wecodeit-project-jakobeckhart-1.avif', name: 'jakobeckhart' },
        { image: 'images/projects/wecodeit-project-xpd-1.avif', name: 'xpd' },
        { image: 'images/projects/wecodeit-project-gc-1.avif', name: 'gc' },
        { image: 'images/projects/wecodeit-project-masaniello-4.avif', name: 'masaniello' },
        { image: 'images/projects/wecodeit-project-leadmetrics-3.avif', name: 'leadmetrics' },
        { image: 'images/projects/wecodeit-project-ziegelwerk-1.avif', name: 'ziegelwerk' },
        { image: 'images/projects/wecodeit-project-ortner-3.avif', name: 'ortner' },
        { image: 'images/projects/wecodeit-project-tecbit-1.avif', name: 'tecbit' },
        { image: 'images/projects/wecodeit-project-hydrotek-2.avif', name: 'hydrotek' },
        {
            image: 'images/projects/wecodeit-project-spinning-moments-1.avif',
            name: 'spinning-moments',
        },
        { image: 'images/projects/wecodeit-project-bier-vom-sir-3.avif', name: 'bier-vom-sir' },
        { image: 'images/projects/wecodeit-project-solarplex-1.avif', name: 'solarplex' },
        { image: 'images/projects/wecodeit-project-user-labs-3.avif', name: 'user-labs' },
        { image: 'images/projects/wecodeit-project-bogner-melkes-2.avif', name: 'bogner-melkes' },
        { image: 'images/projects/wecodeit-project-pertl-3.avif', name: 'pertl' },
        { image: 'images/projects/wecodeit-project-masaniello-2.avif', name: 'masaniello' },
        { image: 'images/projects/wecodeit-project-hydrotek-3.avif', name: 'hydrotek' },
        { image: 'images/projects/wecodeit-project-bier-vom-sir-2.avif', name: 'bier-vom-sir' },
        { image: 'images/projects/wecodeit-project-gc-5.avif', name: 'gc' },
        { image: 'images/projects/wecodeit-project-tgmc-2.avif', name: 'tgmc' },
        { image: 'images/projects/wecodeit-project-gc-4.avif', name: 'gc' },
        { image: 'images/projects/wecodeit-project-tenka-4.avif', name: 'tenka' },
        { image: 'images/projects/wecodeit-project-fcg-younion-1.avif', name: 'fcg-younion' },
        { image: 'images/projects/wecodeit-project-pertl-1.avif', name: 'pertl' },
        { image: 'images/projects/wecodeit-project-seek-1.avif', name: 'seek' },
        { image: 'images/projects/wecodeit-project-gc-3.avif', name: 'gc' },
        { image: 'images/projects/wecodeit-project-solarplex-2.avif', name: 'solarplex' },
        { image: 'images/projects/wecodeit-project-masaniello-2.avif', name: 'masaniello' },
    ];
}
